import { iterateFrom } from 'layout-data-lib/GridLayoutDataTree/utils';
import set from 'hs-lodash/set';
import get from 'hs-lodash/get';
export function getGridLayoutTreeToModifyImmer(draft, treeName) {
  var _draft$gridLayoutTree;
  return (_draft$gridLayoutTree = draft.gridLayoutTrees[treeName]) !== null && _draft$gridLayoutTree !== void 0 ? _draft$gridLayoutTree : draft.schemaGridLayoutTrees[treeName];
}
function copyClonedModuleToGridLayoutModuleImmer(draft, rootId, moduleNode, clonedIdToOriginalIdMap) {
  const clonedNodeId = moduleNode.getId();
  const originalNodeId = clonedIdToOriginalIdMap[clonedNodeId];
  const gridLayoutModule = draft.gridLayoutModules[rootId].find(module => module.name === originalNodeId);
  if (gridLayoutModule) {
    const newModule = Object.assign({}, gridLayoutModule, {
      id: clonedNodeId,
      name: clonedNodeId
    });
    draft.gridLayoutModules[rootId].push(newModule);
  }
}
export function copyClonedModulesToGridLayoutModulesImmer(draft, clonedNode, clonedIdToOriginalIdMap) {
  const rootId = clonedNode.getRootId();
  if (clonedNode.isModule()) {
    copyClonedModuleToGridLayoutModuleImmer(draft, rootId, clonedNode, clonedIdToOriginalIdMap);
  } else {
    iterateFrom(clonedNode, {
      includeStartNode: false,
      gridNodeCallback: ({
        gridNode
      }) => {
        if (gridNode.isModule()) {
          copyClonedModuleToGridLayoutModuleImmer(draft, rootId, gridNode, clonedIdToOriginalIdMap);
        }
      }
    });
  }
}
export function copyGridLayoutFromSchemaToContentImmer(draft, gridLayoutId) {
  const tree = get(draft, ['schemaGridLayoutTrees', gridLayoutId]);
  set(draft, ['gridLayoutTrees', gridLayoutId], tree);
}
export function copyGridLayoutFromSchemaToContentIfNeededImmer(draft, gridLayoutId) {
  if (!get(draft, ['gridLayoutTrees', gridLayoutId])) {
    copyGridLayoutFromSchemaToContentImmer(draft, gridLayoutId);
  }
}